<div class="client-login">

  <div class="subhead">
    <h1 class="confirm-msg">Login Confirmation</h1>
    <div class="login-msg">Continue to login?</div>
  </div>

  <div class="buttons">
    <button id="login-cancel-button" class="btn-cancel" type="button" (click)="cancel()" [mat-dialog-close]>Cancel</button>
    <button id="login-continue-button" class="btn" type="button" (click)="login()">Continue</button>
  </div>


  <button class="reveal-close-button" aria-label="Close login dialog" title="Close" type="button" (click)="cancel()" [mat-dialog-close]>
    <mat-icon [svgIcon]="icons.CLOSE"></mat-icon>
  </button>

</div>
